/**
 * 优惠券到期气泡 / Chat App 用券链路打点
 */

import { trackPayAssistantPoint } from './analytics';

/** Chat App「立即使用」后待提单上报 coupon_success 的券 ID */
let pendingCouponApplyId = null;

/**
 * @param {string | number | null | undefined} rawId
 * @returns {string}
 */
function normalizeCouponId(rawId) {
  return rawId == null || rawId === '' ? '' : String(rawId);
}

/**
 * 优惠券到期气泡展示
 * @param {Record<string, unknown>} [coupon]
 */
export function trackCouponBubbleShow(coupon = {}) {
  trackPayAssistantPoint({
    action: 'coupon_bubble_show',
    category: 'tip',
    actor: 'host',
    tipKind: 'coupon_expire',
    couponId: normalizeCouponId(coupon?.COUPON_ID || ''),
  });
}

/**
 * 点击优惠券到期气泡「去查看」
 * @param {{ tipId?: string, couponId?: string | number }} [context]
 */
export function trackCouponQueryClick(context = {}) {
  trackPayAssistantPoint({
    action: 'coupon_query_click',
    category: 'tip',
    actor: 'host',
    tipKind: 'coupon_expire',
    tipId: context?.tipId || '',
    couponId: normalizeCouponId(context?.couponId || ''),
  });
}

/**
 * Chat App 优惠券卡「立即使用」
 * @param {{ couponId?: string | number } | Record<string, unknown>} [payload]
 */
export function trackCouponApply(payload = {}) {
  const couponId = normalizeCouponId(payload?.couponId || '');
  pendingCouponApplyId = couponId || null;
  trackPayAssistantPoint({
    action: 'coupon_apply',
    category: 'chat',
    actor: 'chat_app',
    couponId,
  });
}

/**
 * 点击「立即使用」后提交订单
 * @param {Record<string, unknown>} [context]
 */
export function maybeTrackCouponSuccess(context = {}) {
  if (!pendingCouponApplyId) return;
  trackPayAssistantPoint({
    action: 'coupon_success',
    category: 'chat',
    actor: 'host',
    tipKind: 'coupon_expire',
    couponId: pendingCouponApplyId,
    activeCouponId: normalizeCouponId(context?.couponId || ''),
    gameId: context?.gameId || '',
    productId: context?.productId || '',
    cpProductId: context?.cpProductId || '',
    fPayType: context?.fPayType || '',
    payType: context?.payType || '',
    isCart: !!context?.isCart,
  });
  pendingCouponApplyId = null;
}

/** 清理待上报状态（页面销毁等场景兜底） */
export function consumeCouponApplyPending() {
  pendingCouponApplyId = null;
}
